import { render, staticRenderFns } from "./ViewerNavBar.vue?vue&type=template&id=63f4df66&scoped=true"
import script from "./ViewerNavBar.vue?vue&type=script&lang=js"
export * from "./ViewerNavBar.vue?vue&type=script&lang=js"
import style0 from "./ViewerNavBar.vue?vue&type=style&index=0&id=63f4df66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f4df66",
  null
  
)

export default component.exports